import { Role, RoleFilters } from "../../api/Role";
import { ToggleFormField } from "../../common/formfields/ToggleFormField";
import { DefinedPropertyObject } from "../../api/GenericTypes";
import {
  TabStoreFilterFormProvider,
  TabStoreFilterSidebarProps,
} from "../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { EntityFilterSideBar } from "../../common/sidebar/filtersidebar/EntityFilterBar";
import {
  CombinedModificationRecordEntityDefaultFormValues,
  combinedModificationRecordEntityFiltersToForm,
  combinedModificationRecordEntityFormToFilters,
  ICombinedModificationRecordEntityForm,
} from "../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterFormModels";
import { CombinedModificationRecordEntityFilterForm } from "../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterForm";

export interface RoleFilterForm extends ICombinedModificationRecordEntityForm {
  includeInternals?: boolean | undefined | null;
}
const defaultValues: DefinedPropertyObject<RoleFilterForm> = {
  includeInternals: null,
  ...CombinedModificationRecordEntityDefaultFormValues,
};

const rolesFormToFilters = (form: RoleFilterForm): RoleFilters => {
  let filters: RoleFilters = {
    ...combinedModificationRecordEntityFormToFilters(form),
  };
  filters.includeInternals = form.includeInternals || false;
  return filters;
};

/**
 * Converts RoleFilters to RoleFilterForm
 * @param filters - The filters to convert
 * @returns The converted form
 * @author @CorradoSurmanowicz
 */
export const rolesFiltersToForm = (filters: RoleFilters): RoleFilterForm => {
  return {
    includeInternals: filters.includeInternals || false,
    ...combinedModificationRecordEntityFiltersToForm(filters),
  };
};

const defaultFilters: RoleFilters = { sortBy: [{ property: "NAME", sortDirection: "ASC" }] };

export const RoleFilterBar = ({
  initialValues,
  onFormChange,
  dispatchTabStore,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<Role, RoleFilterForm, RoleFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultFilters}
      formToFilters={rolesFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <div style={{ minWidth: "200px" }}>
            <ToggleFormField id="includeInternals" control={control} label="Include internals" horizontal />
          </div>

          <CombinedModificationRecordEntityFilterForm
            control={control}
            currentTab={currentTab}
            initialValues={initialValues}
          />
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
